module.exports = __webpack_public_path__ + "img/irigo-mticket.ce8f48d7.png";